import { render, staticRenderFns } from "./CadastroCor.vue?vue&type=template&id=7ddf97f8"
import script from "./CadastroCor.vue?vue&type=script&lang=js"
export * from "./CadastroCor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports